import Vue from "vue";
import VueLazyload from "vue-lazyload";
import c from "@/constants";

Vue.use(VueLazyload, {
  // preLoad: 1.3,
  error: c.IMG_URL + "/no-image.png",
  loading: c.IMG_URL + "/loading.gif"
  // attempt: 3,
  // throttleWait: 500
});
